import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':jobId'}/attachments/directoriesAttachments`;

export const ROUTE: RouteDefinition = `${baseRoute}/:jobId/attachments/directoriesAttachments`;

export const URL = (jobId: number): RouteDefinition => `${baseRoute}/${jobId}/attachments/directoriesAttachments`;
